module.exports = __webpack_public_path__ + "static/media/twitter.c11d008d.svg";